import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorService } from '@cosmos/angular/utils';
import { catchError, map } from 'rxjs';
import { DailyWeatherDto } from '@cosmos/shared';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WeatherService {

  constructor(
    private http: HttpClient,
    private errorService: ErrorService,
  ) { }

  getCurrentWeather(lat: number, lon: number) {
    return this.http
      .get(`${environment.API_URL}/weather/current?lat=${lat}&lon=${lon}`, {observe: 'response'})
      .pipe(
        map(response => {return response;}),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  getForecastWeather(lat: number, lon: number) {
    return this.http
      .get(`${environment.API_URL}/weather/forecast?lat=${lat}&lon=${lon}`, {observe: 'response'})
      .pipe(
        map(response => {return response;}),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  getDailyForecast(lat: number, lon: number, days = 14): import('rxjs').Observable<HttpResponse<DailyWeatherDto[] | {error: string}>> {
    return this.http
      .get<DailyWeatherDto[] | {error: string}>(
        `${environment.API_URL}/weather/daily-forecast?lat=${lat}&lon=${lon}&days=${days}`,
        { observe: 'response' },
      )
      .pipe(
        map(response => response),
        catchError(error => { this.errorService.handleError(error); throw error; }),
      );
  }

  // update(body: any) {
  //   return this.http
  //     .patch(`${environment.API_URL}/stages/${body[0]}`, body[1], {observe: 'response'})
  //     .pipe(
  //       map(response => {return response;}),
  //       catchError( (error) =>{this.errorService.handleError(error); throw error;})
  //     );
  // }

  // delete(id: string) {
  //   return this.http
  //     .delete(`${environment.API_URL}/stages/${id}`, {observe: 'response'})
  //     .pipe(
  //       map(response => {return response;}),
  //       catchError( (error) =>{this.errorService.handleError(error); throw error;})
  //     );
  // }

}
